import axiosInstance from "../axios/axiosInstance";

export const getTags = async (queryParams: string = "") => {
  try {
    let query = "";
    if (queryParams != "") {
      query = `?${queryParams}`;
    }
    const response = await axiosInstance.get(`/tag/collection${query}`);
    return { response, error: null };
  } catch (error) {
    console.log(error);
    return { response: null, error };
  }
};

export const getMasterTag = async (master: string, style: string, queryParams: string = "") => {
  try {
    let query = "";
    if (queryParams != "") {
      query = `&${queryParams}`;
    }
    const response = await axiosInstance.get(`/tag/variant/${master}?style=${style}${query}`);
    return { response, error: null };
  } catch (error) {
    console.log(error);
    return { response: null, error };
  }
};

export const saveTag = async (tagId: string) => {
  try {
    const response = await axiosInstance.post(`/tag/save`, { tag: tagId });
    return { response, error: null };
  } catch (error) {
    console.log(error);
    return { response: null, error };
  }
};

export const saveTags = async (tagIds: string[]) => {
  await Promise.allSettled(
    tagIds.map((tagId) =>
      axiosInstance.post(`/tag/save`, { tag: tagId }).catch(() => null)
    )
  );
};

export const hideTags = async (tagIds: string[]) => {
  try {
    const response = await axiosInstance.post(`/tag/hide`, { tags: tagIds });
    return { response, error: null };
  } catch (error) {
    console.log(error);
    return { response: null, error };
  }
};

export const submitTagApplication = async (body: {
  positive: string;
  generator: string;
  group: string;
  name: string;
  localeKey: string;
}) => {
  try {
    const response = await axiosInstance.post(`/tag/ugc`, body);
    return { response, error: null };
  } catch (error) {
    console.log(error);
    return { response: null, error };
  }
};
